<template>
    <section>
        <!--
        <v-container class="nav">
            <v-card-title>
                <v-avatar class="teal mr-2 elevation-5">
                    <v-icon class="white--text">
                        {{ mdiAlertCircle }}
                    </v-icon>
                </v-avatar>

                <h2>Page Not Found</h2>
            </v-card-title>
        </v-container>
        -->
        <div style="width:100%">
            <div class="d-flex justify-space-around align-center">
                <v-card class="elevation-12 not-found-wrapper" dark shaped>
                    <div class="content-wrapper d-flex justify-space-around align-center flex-column">
                        <div v-if="offline" class="not-found-content d-flex justify-space-around align-center flex-column">
                            <div class="header">
                                <div class="whiteCross">
                                    <img src="../assets/white-cross.svg" alt="">
                                </div>
                                <h2 class="font-weight-black">
                                    Connection Error
                                </h2>
                                <h5 class="my-5 white--text">
                                    Please check your internet connection.
                                </h5>
                                <div class="my-3 text-center" style="width:90%; margin: auto">
                                    If you have concerns with your account, please call HMI (02) 8811-1313. Thank you!
                                </div>
                            </div>
                            <div>
                                <v-btn
                                    color="green accent-4"
                                    class="white--text"
                                    rounded
                                    @click="redirectHome()"
                                >
                                    <v-icon>{{ mdiHome }}</v-icon> Home
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
import { mask } from 'vue-the-mask'
import axios from 'axios'
import { mdiHome } from '@mdi/js'
export default {
    directives: {
        mask
    },
    data: () => ({
        offline: false,
        mdiHome
    }),
    created() {
        axios.get(`${process.env.VUE_APP_API}`, { validateStatus: null })
            .then(() => {
                // console.log(`Status: ${res.status}`);
                window.location.href = '/'
                this.offline = false
            })
            .catch((_) => {
                // console.log(`App Offline`)
                this.offline = true
            })
    },
    methods: {
        redirectHome() {
            window.location.href = '/'
        }
    }
}
</script>
<style scoped>
section{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    background-image: url("../assets/loginBG.webp");
    background-position: center;
    background-size: cover;
}

.not-found-wrapper {
    height: 600px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.content-wrapper {
    height: 100%;
    width: 100%;
    margin: auto;
}

.not-found-content {
    height: 95%;
    width: 100%;
    position: relative;
}

.header {
  text-align: center;
}

span {
  cursor: pointer;
  font-weight: bold;
  color: white;
}

.loginInputs {
  height: 95%;
  width: 100%;
  position: relative;
}

.header h1 {
    font-size: 30px;
}

.whiteCross {
    width: 35%;
    margin: 0 auto;
}

.whiteCross img {
    width: 100%;
}

@media (min-width: 599px) and (max-width: 968px) {
    section {
        height: 100%;
    }
}

@media (max-width: 599px) {
  .not-found-wrapper {
    width: 90%;
    height: 550px;
    padding: 10px 0px;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .not-found-wrapper {
    width: 50%;
    height: 550px;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .not-found-wrapper {
    width: 40%;
    height: 550px;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .not-found-wrapper {
    width: 30%;
    height: 550px;
  }
}
@media (min-width: 1904px) {
  .not-found-wrapper {
    width: 20%;
    height: 600px;
  }
}
</style>
